import React from 'react';

import DoctorInput from 'src/components/user/DoctorInput';
import BaseComponent from 'src/components/BaseComponent';

import { lang } from 'src/helpers';

import model from './model';
import { MCButton } from 'src/components/basic';
import { DoctorCard } from 'src/components/user/DoctorCard';

const apiStateId = 'updateDoctor';

class Doctor extends BaseComponent {
  componentDidMount() {
    model.resetPersonal();
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  savePersonal = (e) => {
    e.preventDefault();
    model.savePersonalDoctor((error) => {
      if (error) {
        setTimeout(() => {
          const els = document.querySelectorAll('.mc-form-invalid-text, .mc-error');
          els.length > 0 &&
            els[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
        }, 300);
      }
    });
  };
  cancel = (e) => {
    e.preventDefault();
    model.resetPersonal();
  };

  render() {
    const { loading, ...createState } = model.getApiState(apiStateId);
    return (
      <form className={'mc-setting-personal'} onSubmit={this.savePersonal}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t('Personal Information')}</div>
        </div>
        <div className={'mc-form'}>
          <div className={'mc-flex-25-col mc-mlr40'}>
            <DoctorCard doctor={model.state.user} model={model} />
            <DoctorInput
              model={model}
              emailReadonly={true}
              phoneReadonly={true}
              imagesEnable={true}
            />
          </div>
        </div>
        {model.state.changed && (
          <div className={'mc-b2t mc-flex mc-p30'}>
            {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
            <div className={'mc-grow'}></div>
            {!loading && (
              <MCButton
                onClick={this.cancel}
                medium
                primary
                radius
                light
                label={lang.t('Cancel')}
                disabled={loading}
              />
            )}
            <MCButton
              type={'submit'}
              medium
              primary
              radius
              dark
              disabled={loading}
              label={!loading ? lang.t('Save Changes') : lang.t('Saving') + '...'}
            />
          </div>
        )}
      </form>
    );
  }
}

export default Doctor;
